import React, { Component } from "react";
import { notification, message, Spin } from 'antd';
import { Legend, PieChart, Pie, Cell, Tooltip} from 'recharts';

const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', 'red', 'pink', '#8884d8', 'black', 'brown', 'cyan',];


  
const RADIAN = Math.PI / 180;
const renderCustomizedLabel = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  percent,
  index
}) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text
      x={x}
      y={y}
      fill="white"
      textAnchor={x > cx ? "start" : "end"}
      dominantBaseline="central"
    >
      {`${(percent * 100).toFixed(0)}%`}
    </text>
  );
};

const style = {
  top: '85%',
  right: 0,
  transform: 'translate(0, -50%)',
  lineHeight: '24px',
};

export default class EstadoCivil extends Component {

  state = {
    estadocivil:[],
    loading: false
  }

  componentDidMount() {
    
    // let id_interval = setInterval(() => {
      const { unidad_medica_user, periodo, backend } = this.props;

      fetch(`${backend}/estadocivil/unidad/${unidad_medica_user}/periodo/${periodo}`,
      {
          method: "GET",
          headers: {
              'Access-Control-Allow-Origin': '*'
          }
      }).then((res) => {
          return res.json();
      }).then((data) => {
          this.setState({
            estadocivil: data.data,
            loading: true
          })
      }).catch((error) => {
          console.log(error);
          notification.error({
              message: 'Error',
              description: "Ocurrió un error al obtener consultas por estado civil.",
          });
          message.destroy()
      });

    // }, 3000);
  }

  
  render(){

    const {estadocivil, loading} = this.state;

    return (
      loading ?
              <PieChart 
                width={450} height={450}  
                className="hsc-piechart-edo-civ"
              >
              <Pie
                className="hsc-pie-edo-civ" 
                data={estadocivil}
                cx={230}
                cy={220}
                labelLine={false}
                label={renderCustomizedLabel}
                outerRadius={200}
                fill="#8884d8"
                dataKey="value"
              >
                {estadocivil.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
              </Pie>
              <Legend iconSize={5} 
                wrapperStyle={style}
                layout='vertical'
                // align='center'
              />
              <Tooltip />
            </PieChart> 
            : <Spin size="small" />
);

    /*
    return(

      <div  style={{ 
        // fontSize: "16px", 
        // "border-radius":"40px", 
        // border: "1px solid", 
        padding: "10px", 
        alignContent:"center",
        width:"490px", //px Para tamaño fijo
        height: "490px"
      }}
      >
        <div
          style={{
            // border: "1px solid", 
            position: "absolute",
            width:"470px",
            height: "470px",
            top: "55%",
            ...styleBorderShadow
            // left: "40%"
          }}
        >
          <div 
            style={{
              position:"absolute",
              top:"5%",
              left:"20%",
              fontSize: "22px"
            }}
          >
            Consultas por Estado Civil
          </div>  

          <PieChart width={450} height={450} 
          style={{
                // ...styleBorderShadow,
              fontSize:"30px",
              left:"2%",
              top:"5%"
            }}  
              className="hsc-pie0-nl"
          >
            <Pie
              className="hsc-pie1-nl" 
              data={estadocivil}
              cx={223}
              cy={180}
              labelLine={false}
              label={renderCustomizedLabel}
              outerRadius={150}
              fill="#8884d8"
              dataKey="value"
            >
              {estadocivil.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
              ))}
            </Pie>
            <Legend iconSize={10} layout="vertical" 
              layout="horizontal"
              wrapperStyle={style}
            />
            <Tooltip />
          </PieChart>  
      </div> 

    
    </div>
    );
    */
  }
}



/*
      <div style={{ fontSize: "16px", 
        padding: "10px", alignContent:"center" }}
      >
        <div
            style={{ 
            padding: "10px", 
            width:"450px",
            "margin-left":"20%"
            }}
          >
        <div style={{...styleBorderShadow, width: 330, height:100, display:"flex", alignItems:"center" }}>
          <p style={{fontSize: "20px", textAlign:"center", padding:"6%"}}>Estado Civil</p>
        </div>   
      </div> 
      
      <PieChart width={450} height={450} 
      style={{
          // background:"red", 
            // border:"1px solid",
            ...styleBorderShadow,
          fontSize:"30px"}}  
          className="hsc-pie0-nl"
      >
        <Pie
          className="hsc-pie1-nl" 
          data={estadocivil}
          cx={223}
          cy={180}
          labelLine={false}
          label={renderCustomizedLabel}
          outerRadius={150}
          fill="#8884d8"
          dataKey="value"
        >
          {estadocivil.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
          ))}
        </Pie>
        <Legend iconSize={10} layout="vertical" 
          // verticalAlign="top" 
          layout="horizontal"
          wrapperStyle={style}
        />
        <Tooltip />
      </PieChart>      
    </div>
*/